import { FC, memo } from "react";
import { PhotoProps } from "./OrderService.interface";

const ImagemotionVideo: FC<PhotoProps> = () => {
  return (
    <div>
      <h1>Imagemotion Video</h1>
      <p>This is the Imagemotion Video component.</p>
    </div>
  );
}

export default memo(ImagemotionVideo);